import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const CrossCircleFilled: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 29c7.168 0 13-5.832 13-13S23.168 3 16 3 3 8.832 3 16s5.832 13 13 13Zm4.364-18.364L16 15l-4.364-4.364-1.414 1.414L14.586 16l-4.364 4.364 1.414 1.414L16 17.414l4.364 4.364 1.414-1.414L17.414 16l4.364-4.364-1.414-1.414Z"
      clipRule="evenodd"
    />
  </Icon>
);
